import axios from 'axios';

const baseUrl = '/auth';

export default {
  login(payload) {
    return axios.post(`${baseUrl}/login`, payload);
  },
  getProfile() {
    return axios.get(`${baseUrl}/profile`);
  },
};
